import PropTypes from 'prop-types';
import React from 'react';
import TextEditor from './TextEditor';
import {
  FormGroup,
  Button,
  ButtonToolbar,
  HelpBlock,
} from 'react-bootstrap';
import { Form, Field } from 'react-final-form';
import MemberDetailModal from './MemberDetailModal';
import { Modal } from 'react-bootstrap';

class ActiveFormatter extends React.Component {
  constructor(props) {
    super(props);
    // self = this;
    this.state = {
      toolbar,
      gridData: false,
      is_group_leader: 0,
    };
    this.toggleRow = this.toggleRow.bind(this);
  }
  componentWillMount() {
    // /console.log('called componentWillMount')
    this.setState({ is_group_leader: this.props.active.is_group_leader });
  }

  toggleRow(values) {
    let temp_Arr = this.props.active.temp_group_leader.filter(itm => itm.grp_id == this.props.active.group_id ? itm.grp_leader : '');
    if (values == 1) {
      console.log(' temp_group_leader1 = '+ this.props.active.temp_group_leader)
      this.setState({ is_group_leader: 0 });
    }
    //&& !(this.props.active.temp_group_leader > 0 || this.props.active.temp_group_leader !== this.props.active.user_id)
    //this.props.active.temp_group_leader == 0
    if (values == 0 && (temp_Arr.length == 0 || (temp_Arr.length && temp_Arr[0].grp_leader == this.props.active.user_id))) {
      console.log(' temp_group_leader0 = '+ this.props.active.temp_group_leader)
      this.setState({ is_group_leader: 1 });
    }
    
    const payload = [];
    payload.values = values;
    payload.row = this.props.active;
    // console.log('payload =' + payload)
    this.props.handleCheckbox(payload);
  }
  render() {
    return (
      <input type="checkbox" checked={this.state.is_group_leader} onClick={() => this.toggleRow(this.state.is_group_leader)} />
    );
  }
}


class TourRosterTable extends React.Component {
  constructor(props) {
    super(props);
    self = this;
    self.options = {
      defaultSortName: 'group',  // default sort column name
      defaultSortOrder: 'desc',  // default sort order
    };

    
    // this.callRender = this.callRender.bind(this);
    this.handleCheckbox = this.handleCheckbox.bind(this);
    this.onClose = this.onClose.bind(this);
    this.deleteMember = this.deleteMember.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.handleHideSetRoomTypes = this.handleHideSetRoomTypes.bind(this);
    this.handleUpdateRoomTypes = this.handleUpdateRoomTypes.bind(this);
    this.refreshDataForParticipant = this.refreshDataForParticipant.bind(this);

    let guest_name = '';
    let temp_group_leader = 0;
    const group_data = [];
    let roster = [];
    const new_arr = [];
    let result = [];
    const group_bid_data = this.props.group_bid_data;
    let rosterData = [];

    let temp = this.props.members.filter(itm => itm.group.group_leader == itm.user_id ? itm.id : '');
    temp_group_leader = temp.length && temp[0].group.group_leader ? temp[0].group.group_leader : 0;
    for (let i=0;i<temp.length;i++){
      result.push({
        grp_id: temp[i].group.id,
        grp_leader: temp[i].group.group_leader
      })
    }
    this.props.members.forEach((member) => {
      let temp_group_data = group_bid_data.filter(itm => itm.travelprofile_id == member.id ? itm : '')
      roster.push({
        id: member.id,
        first_name: member.first_name !== '' ? member.first_name : 'Guest',
        last_name: member.last_name !== '' ? member.last_name : 'Guest',
        is_group_leader: member.group.group_leader == member.user_id ? 1 : 0,
        group: member.group.name,
        group_id: member.group.id,
        user_id: member.user_id,
        temp_group_leader:result,
        email: member.email,
        Suite:(temp_group_data.length && temp_group_data[0].suite !== 'undefined' && temp_group_data[0].suite !== null) ? temp_group_data[0].suite : 0,
        King:(temp_group_data.length && temp_group_data[0].king !== 'undefined' && temp_group_data[0].king !== null) ? temp_group_data[0].king : 0,
        Double:(temp_group_data.length && temp_group_data[0].double !== 'undefined' && temp_group_data[0].double !== null) ? temp_group_data[0].double : 0,
        group_data_id:(temp_group_data.length && temp_group_data[0].id !== 'undefined' && temp_group_data[0].id !== null) ? temp_group_data[0].id : 0,
        phone_number:member.phone_number,
        title:member.title,
        tour_id: this.props.groups[0].tour
      });
      temp_group_data.pop();
    });

    this.state = {
      roster,
      toolbar,
      gridData: false,
      chkBoxVal: -1,
      showConfirm: false,
      showWarning: false,
      showValidationError: false,
      rowData: [],
      modalText: '',
      showMemberModal: false,
      showSetRoomTypes: false,
      member_id:{id:0,
        first_name:"",
        last_name:"",
        email:"",
        group:0,
        phone_number:0,
        title:""},
      groupData: [],
      uniqueGroups: [],
      isDisableApplyBtn: false
    };
    //roster = this.state.roster
  }

  closeModal(){
    this.setState({showMemberModal:false})
  }

  refreshDataForParticipant(){
    let rosterArr = [];
    var groupBidData = this.props.group_bid_data;
    let result = [];
    let temp_group_leader = 0;

    let temp = this.props.members.filter(itm => itm.group.group_leader == itm.user_id ? itm.id : '');
    temp_group_leader = temp.length && temp[0].group.group_leader ? temp[0].group.group_leader : 0;
    for (let i=0;i<temp.length;i++){
      result.push({
        grp_id: temp[i].group.id,
        grp_leader: temp[i].group.group_leader
      })
    }

    this.props.members.forEach((member) => {
      let temp_group_data = groupBidData.filter(itm => itm.travelprofile_id == member.id ? itm : '')
      rosterArr.push({
        id: member.id,
        first_name: member.first_name !== '' ? member.first_name : 'Guest',
        last_name: member.last_name !== '' ? member.last_name : 'Guest',
        is_group_leader: member.group.group_leader == member.user_id ? 1 : 0,
        group: member.group.name,
        group_id: member.group.id,
        user_id: member.user_id,
        temp_group_leader:result,
        email: member.email,
        Suite:(temp_group_data.length && temp_group_data[0].suite !== 'undefined' && temp_group_data[0].suite !== null) ? temp_group_data[0].suite : 0,
        King:(temp_group_data.length && temp_group_data[0].king !== 'undefined' && temp_group_data[0].king !== null) ? temp_group_data[0].king : 0,
        Double:(temp_group_data.length && temp_group_data[0].double !== 'undefined' && temp_group_data[0].double !== null) ? temp_group_data[0].double : 0,
        group_data_id:(temp_group_data.length && temp_group_data[0].id !== 'undefined' && temp_group_data[0].id !== null) ? temp_group_data[0].id : 0,
        phone_number:member.phone_number,
        title:member.title,
        tour_id: this.props.groups[0].tour
      });
      temp_group_data.pop();
    });

    return rosterArr;
  }


  handleCheckbox(Values) {

    const filteredArray = this.props.members.filter(itm => itm.group.id == Values.row.group_id ? itm : '');
    const filteredArray2 = filteredArray.filter(itm => itm.group.group_leader > 0 ? itm.id : '');
    const filteredArray3 = filteredArray2.filter(itm => itm.group.group_leader !== itm.user_id ? itm.id : '');
    const filteredArray_temp = filteredArray2.filter(itm => itm.group.group_leader == itm.user_id ? itm.id : '');
    let is_group_leader = Values.values == 1 ? 0 : 1;
    const tmp = is_group_leader;
    if (is_group_leader) {
      is_group_leader = Values.row.user_id;
    }
    let temp_Arr = Values.row.temp_group_leader.filter(itm => itm.grp_id == Values.row.group_id ? itm.grp_leader : '');
    if((Values.values == 0 && (temp_Arr.length == 0 || (temp_Arr.length && temp_Arr[0].grp_leader == Values.row.user_id))) || Values.values == 1){
      const group = { id: Values.row.group_id };
      const payload = { first_name: Values.row.first_name, last_name: Values.row.last_name, group,group_leader:is_group_leader };
      self.props.editMember(Values.row.id, payload);
      const name = {group_leader: is_group_leader };
      self.props.editGroup(Values.row.group_id, name);
    }else{
      self.setState({ modalText: 'Cannot select checkbox', showWarning: true });
      return false;
    }
    this.setState({ chkBoxVal: Values.values == 1 ? 0 : Values.row.id }, () =>
    console.log(`chkBoxVal =${this.state.chkBoxVal}`));
  }
  onClose() {
    this.setState({
      showConfirm: false,
      showWarning: false,
      showValidationError: false,
    });
  }
  handleHideSetRoomTypes() {
    this.setState({
      showSetRoomTypes: false
    })
  }
  deleteMember() {
    const id = self.state.rowData.id;
    const group_id = self.state.rowData.group_id;
    self.props.dispatchRemoveMemberFromGroup(group_id, id);
    self.setState({ rowData: [], showConfirm: false });
  }
  updateRoster = (e, row,type,enumObject) =>{
    let output = e.target.checked;
    this.setState({roster:enumObject}, () =>
    this.changeCheckBox(output, row, type))
  }
  updateRoomType = (e, row,type,enumObject) =>{
    let selectedRoom = '';
    let unselectedRoom = [];

    switch (type) {
      case 1:
        selectedRoom = "Suite"
        unselectedRoom.push("King")
        unselectedRoom.push("Double")
        break;
      case 2:
        selectedRoom = "King"
        unselectedRoom.push("Suite")
        unselectedRoom.push("Double")
        break;
      case 3:
        selectedRoom = "Double"
        unselectedRoom.push("King")
        unselectedRoom.push("Suite")
        break;
    }

    row[selectedRoom] = 1;
    row[unselectedRoom[0]] = 0;
    row[unselectedRoom[1]] = 0;
    row['room_type'] = type;
    row['tour_id'] = this.props.groups[0].tour;
    row['event_id'] = 0;

    let groupData = this.state.groupData;
    let uniqueGroups = this.state.uniqueGroups;
    let isGroupIncludes = uniqueGroups.includes(row.group_id);
    if(!isGroupIncludes){
      uniqueGroups.push(row.group_id);
      groupData.push(row);
    }
    else{
      groupData.forEach((group)=>{
        if(row.group_id == group.group_id){
          group['Suite'] = row.Suite
          group['King'] = row.King
          group['Double'] = row.Double
          group['room_type'] = row.room_type
        }
      })
    }
    this.setState({
      groupData: groupData,
      uniqueGroups: uniqueGroups
    })
  }
  handleUpdateRoomTypes(){
    this.setState({
      isDisableApplyBtn: true
    })
    let checkedGroupData = this.state.groupData;
    let rosterData = this.state.roster;
    let multipleGrpData = [];
    let index = 0;
    let uniqueGroups = this.state.uniqueGroups;
    
    if(checkedGroupData.length == 0){
      rosterData.forEach((roster)=>{    
        roster.Suite = 0;
        roster.King = 0;
        roster.Double = 0;
        multipleGrpData.push({
          'suite': roster.Suite,
          'king': roster.King,
          'double': roster.Double,
          'room_type': 0,
          'event_id': 0,
          'group_data_id': roster.group_data_id,
          'group_id': roster.group_id,
          'tour_id': roster.tour_id,
          'travelprofile_id': roster.id
        })   
      })
    }else{
      for(let i=0 ; i<checkedGroupData.length ; i++){
        rosterData.forEach((roster)=>{
          if(checkedGroupData[i].group_id == roster.group_id){
            roster.Suite = checkedGroupData[i].Suite;
            roster.King = checkedGroupData[i].King;
            roster.Double = checkedGroupData[i].Double;
            multipleGrpData.push({
              'suite': roster.Suite,
              'king': roster.King,
              'double': roster.Double,
              'room_type': checkedGroupData[i].room_type,
              'event_id': 0,
              'group_data_id': roster.group_data_id,
              'group_id': roster.group_id,
              'tour_id': checkedGroupData[i].tour_id,
              'travelprofile_id': roster.id
            })
          }
        })
      }
    }
    
    if(uniqueGroups.length < (this.props.groups).length){
      for(let i=0; i < rosterData.length; i++){
        if(!uniqueGroups.includes(rosterData[i].group_id)){
          multipleGrpData.push({
            'suite': 0,
            'king': 0,
            'double': 0,
            'room_type': 0,
            'event_id': 0,
            'group_data_id': rosterData[i].group_data_id,
            'group_id': rosterData[i].group_id,
            'tour_id': rosterData[i].tour_id,
            'travelprofile_id': rosterData[i].id
          })
        }
      }
    }

    this.setState({
      roster: rosterData
    })
 
    const payload = {'multiple_grp_data': multipleGrpData}
    this.props.bulkPostGroupData(payload, (response) => {
      window.location.reload();
      this.handleHideSetRoomTypes();
      this.setState({
        groupData: [],
        uniqueGroups: []
      })
    })
  }
  changeCheckBox = (e, row, type) => {

    document.querySelector(`#suite_${row.id}`).disabled = true;
    document.querySelector(`#king_${row.id}`).disabled = true;
    document.querySelector(`#double_${row.id}`).disabled = true;
    const roster = [...this.state.roster];
    const data = roster.find(o => o.id == row.id);

    //let output = e.target.checked;
    let output = e
    let selectedRoom = '';
    let unselectedRoom = [];

    switch (type) {
      case 1:
        selectedRoom = "Suite"
        unselectedRoom.push("King")
        unselectedRoom.push("Double")
        break;
      case 2:
        selectedRoom = "King"
        unselectedRoom.push("Suite")
        unselectedRoom.push("Double")
        break;
      case 3:
        selectedRoom = "Double"
        unselectedRoom.push("King")
        unselectedRoom.push("Suite")
        break;
    }

    data[selectedRoom] = output ? 1 : 0;
    data[unselectedRoom[0]] = 0;
    data[unselectedRoom[1]] = 0;
    data["isDisable"] = true

    //const payloadBid = { suite: data.Suite, king: data.King, double: data.Double, check_in_date: data.check_in_date, check_out_date: data.check_out_date, travelprofile_id: data.id, tour_id: this.props.selectedTourId, group_id: data.group_id, bid_id: this.props.selectedTour.bid_id, event_id: this.props.event.id, id: data.bid_detail_id, room_type: type };
    const payloadBid = { suite: data.Suite, king: data.King, double: data.Double, travelprofile_id: data.id, tour_id: this.props.groups[0].tour, group_id: data.group_id, event_id: 0, room_type: type,group_data_id:data.group_data_id };
    this.props.postGroupData(payloadBid, (response) => {
      data.group_data_id = response.id;
      document.querySelector(`#suite_${row.id}`).disabled = false;
      document.querySelector(`#king_${row.id}`).disabled = false;
      document.querySelector(`#double_${row.id}`).disabled = false;
      this.setState({
        roster
      })
    })

  }

  checkboxsuiteFormatter = (cell, row,enumObject) => {
    const id = `suite_${row.id}`
    return (
      <input type='checkbox' id={id} checked={row.Suite} onChange={(e) => this.updateRoster(e, row, 1,enumObject)} />
    )
  }


  checkboxkingFormatter = (cell, row,enumObject) => {
    const id = `king_${row.id}`
    return (
      <input type='checkbox' id={id} checked={row.King} onChange={(e) => this.updateRoster(e, row, 2,enumObject)} />
    )
  }

  checkboxdoubleFormatter = (cell, row,enumObject) => {
    const id = `double_${row.id}`
    return (
      <input type='checkbox' id={id} checked={row.Double} onChange={(e) => this.updateRoster(e, row, 3,enumObject)} />
    )
  }

  checkboxsuiteFormatterRoomType = (cell, row,enumObject) => {
    let nameAttr = row.group_id + '_roomTypeoptions';
    return (
      <input type='radio' name={nameAttr} id={row.group_id} onChange={(e) => this.updateRoomType(e, row, 1,enumObject)} />
    )
  }


  checkboxkingFormatterRoomType = (cell, row,enumObject) => {
    let nameAttr = row.group_id + '_roomTypeoptions';
    return (
      <input type='radio' name={nameAttr} id={row.group_id} onChange={(e) => this.updateRoomType(e, row, 2,enumObject)} />
    )
  }

  checkboxdoubleFormatterRoomType = (cell, row,enumObject) => {
    let nameAttr = row.group_id + '_roomTypeoptions';
    return (
      <input type='radio' name={nameAttr} id={row.group_id} onChange={(e) => this.updateRoomType(e, row, 3,enumObject)} />
    )
  }
  renderShowsTotal(start, to, total) {
    if(total == 0) {
      return(
        <span></span>
      )
    }
    return (
      <p id="bidsetTableListingPerPage">
       Listings Per Page &nbsp;&nbsp;(From { start } to { to }, Total is { total })
      </p>
    );
  }
  trStyle = (row, rowIndex) => {
      return { backgroundColor: typeof(row) != 'undefined' ? row.bgcolor : ''};
  }

  render() {
    const options = {
      sortIndicator: false ,
      defaultSortName: 'start',
      paginationShowsTotal: this.renderShowsTotal,
      paginationPosition: 'top',
      sizePerPage:25
    };
    let guest_name = '';
    let result = [];
    const roster = [];
    let rosterData = [];
    let uniqueGroups = [];  

    for (let i=0;i<this.props.members.filter(itm => itm.group.group_leader == itm.user_id ? itm.id : '').length;i++){
      if(!result.find(o => o.grp_id == this.props.members.filter(itm => itm.group.group_leader == itm.user_id ? itm.id : '')[i].group.id)){
        result.push({
          grp_id: this.props.members.filter(itm => itm.group.group_leader == itm.user_id ? itm.id : '')[i].group.id,
         grp_leader: this.props.members.filter(itm => itm.group.group_leader == itm.user_id ? itm.id : '')[i].group.group_leader
       })
     }
    }
      this.props.members.forEach((member) => {
        let temp_group_data = this.props.group_bid_data.filter(itm => itm.travelprofile_id == member.id ? itm : '')
          roster.push({
            id: member.id,
            first_name: member.first_name !== '' ? member.first_name : 'Guest',
            last_name: member.last_name !== '' ? member.last_name : 'Guest',
            is_group_leader: member.group.group_leader == member.user_id ? 1 : 0,
            group: member.group.name,
            group_id: member.group.id,
            user_id: member.user_id,
            temp_group_leader:result,
            email: member.email,
            Suite:(temp_group_data.length && temp_group_data[0].suite !== 'undefined' && temp_group_data[0].suite !== null) ? temp_group_data[0].suite : 0,
            King:(temp_group_data.length && temp_group_data[0].king !== 'undefined' && temp_group_data[0].king !== null) ? temp_group_data[0].king : 0,
            Double:(temp_group_data.length && temp_group_data[0].double !== 'undefined' && temp_group_data[0].double !== null) ? temp_group_data[0].double : 0,
            group_data_id:(temp_group_data.length && temp_group_data[0].id !== 'undefined' && temp_group_data[0].id !== null) ? temp_group_data[0].id : 0,
            phone_number:member.phone_number,
            title:member.title
          });

          temp_group_data.pop();
    })

    roster.forEach((row) =>{
      let isGroupIncludes = uniqueGroups.includes(row.group_id);
      if(!isGroupIncludes){
        uniqueGroups.push(row.group_id);
        rosterData.push({       
          group: row.group,
          group_id: row.group_id,
          group_data_id: row.group_data_id
        })
      }
    })

    const checkboxFormatter = (cell, row) => <div>
      <ActiveFormatter active={row} handleCheckbox={this.handleCheckbox} />
    </div>
    const buttonFormatter = (cell, row) => <div>
      <Button onClick={() => getRow(cell, row)} ><i className="fa fa-pencil fa-lg" style={{ bordercolor: '#5bc0e8 !important' }} /></Button>&nbsp;&nbsp;&nbsp;&nbsp;
      <Button onClick={() => cancelRow(cell, row)} ><i className="fa fa-remove" style={{ bordercolor: '#5bc0e8' }} /></Button>

    </div>;

    function getRow(cell, row) {
      self.setState(prevState => ({
        member_id: {                   // object that we want to update
            ...prevState.member_id,    // keep all other key-value pairs
            id: row.id,
            first_name:row.first_name,
            last_name:row.last_name,
            email:row.email,
            group:row.group_id,
            phone_number:row.phone_number,
            title:row.title       // update the value of specific key
        }
    }))
    self.setState({showMemberModal:true}) 
      let is_group_leader = 0;
      const filteredArray = self.props.members.filter(itm => itm.group.id == row.group_id ? itm : '');
      if(row.is_group_leader !== row.user_id){
      if (self.state.chkBoxVal && self.state.chkBoxVal == row.id) {
        const filteredArray2 = filteredArray.filter(itm => itm.group.group_leader > 0 ? itm.id : '');
        const filteredArray3 = filteredArray2.filter(itm => itm.group.group_leader !== itm.user_id ? itm.id : '');
        const filteredArray_temp = filteredArray2.filter(itm => itm.group.group_leader == itm.user_id ? itm.id : '');
        
        if (filteredArray3.length && self.state.chkBoxVal !== filteredArray_temp[0].id) {
          self.setState({ modalText: 'Cannot select checkbox', showWarning: true });
          return false;
        } else {
          if (self.state.chkBoxVal) {
            is_group_leader = row.user_id;
          }
          const group = { id: row.group_id };
          const payload = {id:cell, first_name: row.first_name, last_name: row.last_name, group };
          self.props.editMember(cell, payload);
          const name = { name: row.group, group_leader: is_group_leader };
          self.props.editGroup(row.group_id, name);
          self.setState({gridData:true})
        }
      }
    }
      if (self.state.chkBoxVal == 0) {
        if (self.state.chkBoxVal) {
          is_group_leader = row.user_id;
        }
        const group = { id: row.group_id };
        const payload = { id:cell, first_name: row.first_name, last_name: row.last_name, group };

        self.props.editMember(cell, payload);
        if(row.is_group_leader){
          const name = { name: row.group, group_leader: 0 };  
          self.props.editGroup(row.group_id, name);
        }else{
          const name = { name: row.group};
          self.props.editGroup(row.group_id, name);
        }
      }
        const group = { id: row.group_id };
        const payload = {id:cell, first_name: row.first_name, last_name: row.last_name, group };
        self.props.editMember(cell, payload);
    }
    function cancelRow(cell, row) {
      self.setState({ showConfirm: true, rowData: row });
      row.guests = guest_name;
      row.group = row.id.group;
      row.is_group_leader = row.id.is_group_leader;
    }
    function handleShowSetRoomTypes() {
      let rosterArr = self.refreshDataForParticipant();
      self.setState({ showSetRoomTypes: true, roster: rosterArr, isDisableApplyBtn: false});
    }
    function handleHideSetRoomTypes() {
      self.setState({ showSetRoomTypes: false });
    }
    function onBeforeSaveCell(row, cellName, cellValue) {        
      if((cellName == 'first_name' || cellName == 'last_name') &&  cellValue && !isNaN(cellValue)){
        self.setState({ modalText: "Name of the Participant can't be a Number.", showValidationError: true });
        return false;
      }
      guest_name = row.guests;
      return true;
    }
    function enumFormatter(cell, row, enumObject) {
      return enumObject[cell];
    }

    const qualityType = {
      0: 'good',
      1: 'Bad',
      2: 'unknown'
    };
    let groupList = [];
    this.props.groups.forEach((groupElement) => {
      groupList[groupElement.id] = groupElement.name;
    });

    const cellEditProp = {
      mode: 'dbclick',
      blurToSave: true,
      beforeSaveCell: onBeforeSaveCell, // a hook for before saving cell
    };
    // group filter      
    //  filterFormatted dataFormat={ enumFormatter } formatExtraData={ groupList } filter={ { type: 'SelectFilter', options: groupList }}
    return (
      <div>{this.props.isLoading==true?(
        <div style={{padding: '0px 0px 30px 280px'}}>
          <i className="fa fa-spinner fa-pulse fa-5x fa-fw" />
          <span className="sr-only">Loading...</span>
        </div>):(

      <div>
      {this.props.groups.length && this.props.members.length && (<Button bsStyle="success" className="bulk-set-room-types-btn" onClick={() => handleShowSetRoomTypes()}><i className="fa fa-pencil fa-lg"/> Default Room Types</Button>)}
        <BootstrapTable
          data={roster}
          trStyle = { this.trStyle }
          options = { options }
          striped
          pagination
          cellEdit={cellEditProp}
          search
        >        
          <TableHeaderColumn dataField="first_name" width="80" headerAlign="center" dataAlign="center" editable={{ type: 'text' }}>First Name</TableHeaderColumn>
          <TableHeaderColumn dataField="last_name" width="80" headerAlign="center" dataAlign="center" editable={{ type: 'text' }}>Last Name</TableHeaderColumn>
          <TableHeaderColumn dataField="email" width="100" headerAlign="center" dataAlign="center" editable={false} >Email</TableHeaderColumn>
          <TableHeaderColumn dataField="group" width="80" headerAlign="center" dataAlign="center" editable={false} >Sub-Group</TableHeaderColumn>
          <TableHeaderColumn dataField="Suite" width="50" headerAlign="center" dataAlign="center" dataFormat={this.checkboxsuiteFormatter} editable={false} formatExtraData={roster}>Suite</TableHeaderColumn>
          <TableHeaderColumn dataField="King" width="50" headerAlign="center" dataAlign="center" dataFormat={this.checkboxkingFormatter} editable={false} formatExtraData={roster}>King</TableHeaderColumn>
          <TableHeaderColumn dataField="Double" width="50" headerAlign="center" dataAlign="center" dataFormat={this.checkboxdoubleFormatter} editable={false} formatExtraData={roster}>Double</TableHeaderColumn>
          <TableHeaderColumn dataField="is_group_leader" width="70" headerAlign="center" dataAlign="center" dataFormat={checkboxFormatter} editable={false}>Group Leader</TableHeaderColumn>
          <TableHeaderColumn dataField="id" width="85" isKey headerAlign="center" dataAlign="center" dataFormat={buttonFormatter} editable={false}>Action</TableHeaderColumn>
          <TableHeaderColumn dataField="group_id" width="1" headerAlign="center" dataAlign="center" hidden>Group ID</TableHeaderColumn>
          <TableHeaderColumn dataField="user_id" width="1" headerAlign="center" dataAlign="center" hidden>User ID</TableHeaderColumn>
          <TableHeaderColumn dataField="temp_group_leader" width="1" headerAlign="center" dataAlign="center" hidden>temp_group_leader</TableHeaderColumn>
          <TableHeaderColumn dataField="group_data_id" width="1" headerAlign="center" dataAlign="center" hidden>group_data_id</TableHeaderColumn>
          <TableHeaderColumn dataField="phone_number" width="1" headerAlign="center" dataAlign="center" hidden>phone_number</TableHeaderColumn>
          <TableHeaderColumn dataField="title" width="1" headerAlign="center" dataAlign="center" hidden>title</TableHeaderColumn>
        </BootstrapTable>

        {self.state.showConfirm && (<Modal show={self.state.showConfirm} onHide={self.onClose}>
          <Modal.Header closeButton>
            <Modal.Title>Delete Member</Modal.Title>
          </Modal.Header>
          <Modal.Body>

            <p> {self.state.modalText !== '' ? self.state.modalText : 'Are you sure want to delete member?'}</p>

            <ButtonToolbar style={{ float: 'right' }}>
              <Button
                bsStyle="success"
                onClick={self.deleteMember}
              >
                            Confirm
                          </Button>
              <Button
                bsStyle="success"
                onClick={self.onClose}
              >
                            Cancel
                          </Button>
            </ButtonToolbar>
          </Modal.Body>
          <Modal.Footer style={{ clear: 'both' }} />
        </Modal>
        )}
        {self.state.showWarning && (<Modal show={self.state.showWarning} onHide={self.onClose}>
          <Modal.Header closeButton>
            <Modal.Title>Group Leader</Modal.Title>
          </Modal.Header>
          <Modal.Body>

            <p> There cannot be more than 1 group leader per group</p>

            <ButtonToolbar style={{ float: 'right' }}>
              <Button
                bsStyle="success"
                onClick={self.onClose}
              >
                            Ok
                          </Button>
            </ButtonToolbar>
          </Modal.Body>
          <Modal.Footer style={{ clear: 'both' }} />
        </Modal>
        )}

        {self.state.showSetRoomTypes && (<Modal show={self.state.showSetRoomTypes} onHide={this.handleHideSetRoomTypes} backdrop="static">
          <Modal.Header closeButton>
          <Modal.Title>Default Room Types</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div id="setRoomTypeModalSection">
              <BootstrapTable
                data={rosterData}
                striped
                >
                <TableHeaderColumn dataField="group" width="80" headerAlign="center" dataAlign="center" editable={false} >Group</TableHeaderColumn>
                <TableHeaderColumn dataField="Suite" width="50" headerAlign="center" dataAlign="center" dataFormat={this.checkboxsuiteFormatterRoomType} editable={false}>Suite</TableHeaderColumn>
                <TableHeaderColumn dataField="King" width="50" headerAlign="center" dataAlign="center" dataFormat={this.checkboxkingFormatterRoomType} editable={false}>King</TableHeaderColumn>
                <TableHeaderColumn dataField="Double" width="50" headerAlign="center" dataAlign="center" dataFormat={this.checkboxdoubleFormatterRoomType} editable={false}>Double</TableHeaderColumn>
                <TableHeaderColumn dataField="group_id" isKey width="1" headerAlign="center" dataAlign="center" hidden>Group ID</TableHeaderColumn>
                <TableHeaderColumn dataField="group_data_id" width="1" headerAlign="center" dataAlign="center" hidden>group_data_id</TableHeaderColumn>
              </BootstrapTable>
            </div>
              <ButtonToolbar className="margin-top-5" style={{ float: 'right'}}>
                <Button
                  bsStyle="success"
                  onClick={this.handleUpdateRoomTypes}
                  disabled={this.state.isDisableApplyBtn}
                  >
                  Apply
                </Button>
              </ButtonToolbar>
          </Modal.Body>
          <Modal.Footer style={{ clear: 'both' }} />
          </Modal>
          )}

        {self.state.showValidationError && (<Modal show={self.state.showValidationError} onHide={self.onClose}>
          <Modal.Header closeButton>
            <Modal.Title>Incorrect data</Modal.Title>
          </Modal.Header>
          <Modal.Body>

            <p> {self.state.modalText !== '' ? self.state.modalText : 'Please enter valid data.'}</p>

            <ButtonToolbar style={{ float: 'right' }}>
              <Button
                bsStyle="success"
                onClick={self.onClose}
              >
                            Ok
                          </Button>
            </ButtonToolbar>
          </Modal.Body>
          <Modal.Footer style={{ clear: 'both' }} />
        </Modal>
        )}
        { self.state.showMemberModal && (
            <MemberDetailModal
              tourId={this.props.tourId}
              //member={this.props.user}
              member={self.state.member_id}
              show={self.state.showMemberModal}
              onClose={this.closeModal}
              addMember={this.props.addMember}
              editMember={this.props.editMember}
              groups={this.props.groups}
              readOnly={this.props.readOnly}
              dispatchRemoveMemberFromGroup={this.props.dispatchRemoveMemberFromGroup}
              isParticipantGrid={true}
            />
          )}

        {/* <ButtonToolbar style={{ float: "right" }}>{self.state.modalText == '' ? <Button bsStyle="success" onClick={self.deleteMember}></Button><Button bsStyle="success" onClick={self.onClose}>Cancel</Button> : <Button bsStyle="success" onClick={self.onClose}>Ok</Button>}</ButtonToolbar>   */}
      
      </div>)}
      </div>
    );
  }
}
TourRosterTable.propTypes = {
  members: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  handleRemoveMember: PropTypes.func.isRequired,
  handleEditMember: PropTypes.func.isRequired,
  readOnly: PropTypes.bool.isRequired,
  editMember: PropTypes.func.isRequired,
};
export default TourRosterTable;



// WEBPACK FOOTER //
// src/routes/tours/components/TourRosterTable.js